export const PATHS = {
  HOME: '/',
}
